<template>
  <BModal
    id="modal-confirm-approval"
    hide-footer
    hide-header
    :centered="true"
    content-class="rounded-lg"
    @shown="onShown"
  >
    <div class="text-center p-1">
      <img
        src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
        alt="Konfirmasi"
        class="mx-auto"
        width="80px"
      >
      <div class="font-semibold text-[18px] text-[#333333] my-2">
        Setujui Pengajuan WL?
      </div>
      <div class="mb-2">
        <p>Silahkan isi nama akun WL yang akan disetujui</p>
      </div>
      <ValidationProvider
        v-slot="{ errors }"
        name="Nama akun WL"
        rules="required"
      >
        <div class="mb-2 text-left">
          <label class="text-[#333333] text-[14px] font-semibold mb-1 block">
            Nama akun WL sesuai format
            <span class="text-primary">*</span>
          </label>
          <BFormInput
            v-model="form.account_name"
            :class="{ 'is-invalid': errors.length > 0 || validationError.account_name }"
            placeholder="KomAds WL 258 - Erlan Sumanto - 03 | 2159"
          />
          <span
            v-if="errors.length > 0 || validationError.account_name"
            class="text-danger text-sm"
          >{{ errors[0] || validationError.account_name }}</span>
        </div>
      </ValidationProvider>

      <div v-if="platform === 'meta'">
        <!-- Business Manager -->
        <ValidationProvider
          v-slot="{ errors }"
          name="Business Manager"
          rules="required"
        >
          <div class="mb-2 text-left">
            <label class="text-[#333333] text-[14px] font-semibold mb-1 block">
              Pilih Business Manager
              <span class="text-primary">*</span>
            </label>
            <BFormSelect
              v-model="form.system_bm_id"
              :options="metaBusinessManagerOptions"
              :class="{ 'is-invalid': errors.length }"
            />
            <span
              v-if="errors.length > 0 || validationError.system_bm_id"
              class="text-danger text-sm"
            >{{ errors[0] || validationError.system_bm_id }}</span>
          </div>
        </ValidationProvider>

        <!-- Ad Account ID -->
        <ValidationProvider
          v-slot="{ errors }"
          rules="required|numeric"
          name="ID Ad Account"
        >
          <div class="mb-[16px] text-left">
            <label
              class="text-[#333333] text-[14px] font-medium mb-[8px] block"
            >
              Masukkan ID Ad Account <span class="text-primary">*</span>
            </label>
            <BFormInput
              v-model="form.ad_account_id"
              placeholder="Masukkan ID Ad Account Disini"
              class="w-full"
              required
            />
            <span
              v-if="errors.length > 0 || validationError.ad_account_id"
              class="text-danger text-sm"
            >{{ errors[0] || validationError.ad_account_id }}</span>
          </div>
        </ValidationProvider>

      </div>

      <div class="flex flex-row gap-6">
        <BButton
          variant="outline-primary"
          class="rounded grow"
          @click="$bvModal.hide('modal-confirm-approval')"
        >
          Batal
        </BButton>

        <BButton
          variant="primary"
          class="rounded grow"
          :disabled="!form.account_name"
          @click="confirmApproval()"
        >
          Setujui
        </BButton>
      </div>
    </div>
  </BModal>
</template>

<script>
import { newAxiosIns } from '@/libs/axios'
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'ModalConfirmApproval',
  components: {
    ValidationProvider,
  },
  props: {
    validationError: {
      type: Object,
      default: () => ({
        account_name: '',
        system_bm_id: '',
        ad_account_id: '',
      }),
    },
    platform: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      form: {
        status: 'accepted',
        account_name: '',
        system_bm_id: '',
        ad_account_id: '',
      },
      metaBusinessManagerOptions: [],
    }
  },
  methods: {
    /**
     * Handler executed when the component or modal is shown.
     *
     * - Only runs when the selected platform is `meta`
     *
     * @returns {void}
     */
    onShown() {
      if (this.platform !== 'meta') return
      this.loadSystemBusinessManagerList()
    },
    /**
     * Fetches the system Meta Business Manager list from the API.
     *
     * - Calls the system BM endpoint
     * - Maps API response into `metaBusinessManagerOptions`
     *   for select/dropdown usage
     * - Shows an error toast if the request fails
     *
     * @async
     * @returns {Promise<void>}
     */
    async loadSystemBusinessManagerList() {
      try {
        const {
          data: { data },
        } = await newAxiosIns.get('komads/api/v1/admin/system_bm/list')

        this.metaBusinessManagerOptions = [
          { value: '', text: 'Pilih Business Manager' },
          ...data.map(system => ({
            value: `${system.id}`,
            text: `${system.bm_name} - ${system.bm_id}`,
          })),
        ]
      } catch {
        this.$toast_error({
          message: 'Failed to load business manager list',
        })
      }
    },
    /**
     * Emits an event to the parent component to confirm the approval.
     */
    confirmApproval() {
      this.$emit('confirm-approval', this.form)
      this.$bvModal.hide('modal-confirm-approval')
    },
  },
}
</script>
